import { render, staticRenderFns } from "./GroupRowPermission.vue?vue&type=template&id=3ddf3052&scoped=true&"
import script from "./GroupRowPermission.vue?vue&type=script&lang=ts&"
export * from "./GroupRowPermission.vue?vue&type=script&lang=ts&"
import style0 from "./GroupRowPermission.vue?vue&type=style&index=0&id=3ddf3052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddf3052",
  null
  
)

export default component.exports